import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";
import { Chapter, Reveal } from "./shared";

const FAQ = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" data-testid="faq-section" className="section-alt">
      <div className="relative mx-auto max-w-3xl px-5 sm:px-8 py-20 sm:py-28">
        <Chapter title={t.faq.title} />

        <Reveal>
          <Accordion type="single" collapsible className="faq-accordion w-full space-y-4">
            {t.faq.items.map((item) => (
              <AccordionItem
                key={item.id}
                value={item.id}
                data-testid={`faq-item-${item.id}`}
                className="card-elevated rounded-2xl border-b-0 px-6 sm:px-7 data-[state=open]:border-amber-500/40 data-[state=open]:shadow-[inset_0_1px_0_rgba(255,255,255,0.1),0_22px_44px_-14px_rgba(0,0,0,0.65),0_20px_50px_-24px_rgba(234,179,8,0.2)]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${item.id}`}
                  className="py-6 text-left font-heading text-base sm:text-lg font-semibold tracking-[-0.01em] transition-colors duration-300 hover:text-amber-300 hover:no-underline [&[data-state=open]>svg]:text-amber-400"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent forceMount className="pb-6 text-sm sm:text-base leading-relaxed text-slate-400">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
